import { render, staticRenderFns } from "./AjustReferral.vue?vue&type=template&id=8869b208&scoped=true"
import script from "./AjustReferral.vue?vue&type=script&lang=js"
export * from "./AjustReferral.vue?vue&type=script&lang=js"
import style0 from "./AjustReferral.vue?vue&type=style&index=0&id=8869b208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8869b208",
  null
  
)

export default component.exports